import React from 'react';
import CarouselBox from '../components/CarouselBox.jsx'
import {introduction_main, introduction} from './../introduction.jsx'
import {Params} from './../params.jsx'
import SecondHead from './../components/SecondHead'
import IMG_0022 from '../assets/images/IMG_0022.jpg';
import IMG_0001 from '../assets/images/IMG_0001.jpg';
import IMG_0002 from '../assets/images/IMG_0002.jpg';
import IMG_0017 from '../assets/images/IMG_0017.jpg';
import IMG_0018 from '../assets/images/IMG_0018.jpg';
import IMG_0019 from '../assets/images/IMG_0019.jpg';
import IMG_bonichi_1 from '../assets/images/IMG_bonichi_1.jpeg';
import IMG_bonichi_2 from '../assets/images/IMG_bonichi_2.jpeg';
import IMG_bonichi_3 from '../assets/images/IMG_bonichi_3.jpeg';
import IMG_bbq from '../assets/images/IMG_bbq.jpeg';
import IMG_bbq_1 from '../assets/images/IMG_bbq1.jpeg';
import IMG_all2 from '../assets/images/IMG_all2.jpeg';
import IMG_beach from '../assets/images/IMG_beach.jpeg';
import { YMaps, Map, Placemark} from '@pbe/react-yandex-maps';




const images = [
    IMG_0022, IMG_0001, IMG_0002, IMG_0017, IMG_0018, IMG_0019]
const images_2 = [
    IMG_bonichi_1, IMG_bonichi_2, IMG_bonichi_3, IMG_bbq, IMG_bbq_1, IMG_all2, IMG_beach]


function Start(props){

    return(
        <>
         <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container mt-2 bg1 mymarge ">
            <div className="row">
                <div className="col-md-9 d-flex justify-content-center align-items-center">

                    <div className="mysize d-flex justify-content-center align-items-center">
                            <CarouselBox img = {images}/> 
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="inter_description bg1 h-75 mt-md-5 pt-md-5">
                       <div className='description mymarge fs-5'> {introduction_main(props.lang)}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="about" className="container mt-2 bg2 mymarge">
            <div className="row">
                <div className="col text-center">
                    <h3>{Params(props.lang).brand}</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-9 about-slide p-5 d-flex justify-content-center align-items-center">
                    <div className="mysize d-flex justify-content-center align-items-center">
                        <CarouselBox img = {images_2}/>
                    </div>    
                </div>
                <div className="col-md-3 d-flex flex-column justify-content-center ">
                    <div className="h-50" >

                        <div className="border border-primary">
                            <YMaps query = {{apikey:"dbf8b9af-6025-4d15-ad19-4ff70914326c"}}>
                                <Map defaultState={{ center: [42.418353, 18.709875], zoom: 16}} width='100%' height='200px'>
                                    <Placemark defaultGeometry={[42.418353, 18.709875]} />
                                </Map>
                            </YMaps>
                        </div>

                    </div>
                </div>
            </div>
            <div className="row ">
                <div className="col pt-5 pb-5 fs-5 ">
                    {introduction(props.lang)}
                    
                </div>
            </div>

        </div>

        </>
        )

}
    export default Start;